import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#222",
		fillRule: "evenodd",
		d: "M9.3 1c.517 0 1.013.201 1.379.56.365.357.571.843.571 1.35v.635h2.6c.359 0 .65.285.65.637a.643.643 0 0 1-.65.636h-.65v8.273c0 .506-.206.992-.571 1.35-.366.358-.862.559-1.379.559h-6.5a1.97 1.97 0 0 1-1.379-.56 1.9 1.9 0 0 1-.571-1.35V4.819h-.65a.643.643 0 0 1-.65-.636c0-.352.291-.637.65-.637h2.6V2.91c0-.506.206-.992.571-1.35C5.687 1.201 6.183 1 6.7 1zM6.7 2.273a.66.66 0 0 0-.46.186.63.63 0 0 0-.19.45v.636h3.9V2.91a.63.63 0 0 0-.19-.45.66.66 0 0 0-.46-.186z",
		clipRule: "evenodd"
	})
});
export default SvgDelete;
